module.exports = __webpack_public_path__ + "img/big_1_35.9ce61ff4.png";